// extracted by mini-css-extract-plugin
export default {"Box":"y-axis-selector-module__Box__fZVGTyS","SelectorLabel":"y-axis-selector-module__SelectorLabel__oQBSMAN","ActionMenu_Button":"y-axis-selector-module__ActionMenu_Button__hYrJtKS"};